import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Layout, PageHeader, Tabs } from 'antd';
import { RETURN_TO_HOME } from './constants';
import { ConfigNav } from './styled';
import { hasAttributeValue, hasResourceOperation } from '../../../util/index';
import {
  ITEM_OPERATIONS,
  TM_FRAUD_SOURCE_IDS
} from '../../../util/GlobalConstant';
import { getSelectedResources } from '../../../util/resourceManager';
import Detection from './Detection';
import Prevention from './Prevention';

const { TabPane } = Tabs;

// NAMED EXPORT for the tests, unwrapped. The default is wrapped in
// `withRouter`, whose react-router v4 implementation uses the legacy context
// API and does not inject under this harness — so the wrapped component cannot
// be driven from a test at all. `Prevention` is taken the same way, and for the
// same reason.
export const ConfigureRunInstance = ({ history, location, authentication }) => {
  const { trmResources } = getSelectedResources();

  const returnToRunInstance = () => {
    history.push(RETURN_TO_HOME);
  };

  const query = new URLSearchParams(location.search);

  return (
    <Layout className="layout">
      <PageHeader
        ghost={false}
        onBack={returnToRunInstance}
        title="Run Instance"></PageHeader>
      <ConfigNav>
        <Tabs defaultActiveKey={query?.get('tab') || '1'}>
          {(hasAttributeValue(
            authentication,
            trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
            TM_FRAUD_SOURCE_IDS.TM
          ) && (
            <TabPane tab="Detection" key="1">
              <Detection />
            </TabPane>
          )) ||
            (hasAttributeValue(
              authentication,
              trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
              TM_FRAUD_SOURCE_IDS.FRAUD
            ) && (
              <TabPane tab="Detection" key="1">
                <Detection />
              </TabPane>
            ))}

          {hasAttributeValue(
            authentication,
            trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
            '24'
          ) && (
            <TabPane tab="Prevention" key="2">
              <Prevention history={history} location={location} />
            </TabPane>
          )}
        </Tabs>
      </ConfigNav>
    </Layout>
  );
};

ConfigureRunInstance.propTypes = {
  history: PropTypes.object,
  // Both were already destructured above but undeclared — lint errors that
  // predate this change. Declared now because `location` is handed down to
  // Prevention, so its shape is part of this component's contract.
  location: PropTypes.object,
  authentication: PropTypes.object
};

export default withRouter(ConfigureRunInstance);
